import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';

export interface UseControlledStateProps<S> {
    state?: S | (() => S);
    setState?: Dispatch<SetStateAction<S>>;
    defaultState?: S | (() => S);
}

export const useControlledState = <S = undefined>({
    state,
    setState,
    defaultState,
}: UseControlledStateProps<S>) => {
    const [localState, setLocalState] = useState(defaultState);

    const safeState = state ?? localState;
    const safeSetState = setState || setLocalState;

    return [safeState as S, safeSetState] as const;
};
